import { useState } from "react";
import { FiTarget, FiStar, FiUsers, FiInfo } from "react-icons/fi";
import Navbar from "./components/navbar";
import Footer from "./components/Footer";
import { VisionContent } from "./components/vision";
import { MissionContent } from "./components/mission";
import { SuccessStoriesContent } from "./components/sucess_storeis";
import { WhoWeAreContent } from "./components/who_we_are";

const AboutUs = () => {
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchBarOpen, setSearchBarOpen] = useState(false);

  // const toggleMobileMenu = () => {
  //   setMobileMenuOpen(!mobileMenuOpen);
  // };

  const handleSearchIconClick = () => {
    setSearchBarOpen(!searchBarOpen);
  };

  const tabs = [
    { key: "whoweare", label: "Who We Are", icon: <FiInfo className="w-5 h-5 mr-2" /> },
    { key: "vision", label: "Our Vision", icon: <FiTarget className="w-5 h-5 mr-2" /> },
    { key: "mission", label: "Our Mission", icon: <FiStar className="w-5 h-5 mr-2" /> },
    { key: "stories", label: "Success Stories", icon: <FiUsers className="w-5 h-5 mr-2" /> },
  ] as const;
  type TabKey = typeof tabs[number]["key"];
  const [activeTab, setActiveTab] = useState<TabKey>("whoweare");
  // mobile accordion open key (keeps desktop tab selection and mobile open state in sync)
  // const [mobileOpen, setMobileOpen] = useState<TabKey | null>("vision");

  return (
    <div
      className="min-h-screen relative flex flex-col overflow-x-hidden"
      style={{
        background:
          "radial-gradient(35% 19% at 50% 0%, rgba(255, 84, 31, 0.5) 0%, rgba(0, 0, 0, 0) 100%), black",
        color: "white",
      }}
    >
      {/* Mobile-only tweaks */}
      <style>{`
        @media (max-width: 640px) {
          .bg-dots { display: none !important; }
        }
      `}</style>

      {/* Add Dots Pattern Background */}
      <div
        className="absolute bg-dots"
        style={{
          width: "1106px",
          height: "500px",
          top: "-12px",
          left: "194px",
          backgroundImage: "url('/dots.png')",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          opacity: 1,
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 0,
        }}
      />

      {/* Top Nav */}
      <div className="w-full bg-transparent border-b border-white/10 shadow-sm relative z-[1000]">
        <Navbar
          onSearchClick={handleSearchIconClick}
          // mobileMenuOpen={mobileMenuOpen}
          // toggleMobileMenu={toggleMobileMenu}
        />
      </div>

      {/* Main Container */}
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-12 lg:px-24 flex flex-col flex-1 pb-16">
        {/* Page title */}
        <div className="relative z-10 w-full flex justify-center mt-30 mb-20">
          <h1
            className="font-[Sora] font-semibold text-[28px] leading-[150%] text-center"
            style={{
                fontSize: "35px",
              color: "rgba(255, 255, 255, 1)",
              letterSpacing: "0%",
            }}
          >
            About us
          </h1>
        </div>

        {/* Layout */}
        <div className="flex flex-1 gap-8 relative z-10">
          {/* Desktop Tabs (Left) */}
          <div className="w-48 shrink-0 hidden md:flex flex-col gap-3 md:fixed md:top-38 md:left-8 h-fit z-20">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => {
                  setActiveTab(t.key);
                  window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top on tab click
                }}
                className={`flex items-center text-left rounded-md px-4 py-3 text-sm font-medium transition border
                  ${
                    activeTab === t.key
                      ? "bg-orange-500 text-white border-orange-500 shadow"
                      : "bg-black border-white/10 text-white hover:bg-white/5"
                  }`}
                style={
                  activeTab === t.key
                    ? { background: "rgba(255, 84, 31, 1)" }
                    : undefined
                }
              >
                {t.icon}
                {t.label}
              </button>
            ))}
          </div>

          {/* Mobile stacked content */}
          <div className="md:hidden flex flex-col gap-8 w-full">
            <div className="space-y-8">
              <div className="bg-black/20 border border-white/10 rounded-lg p-4">
                <div className="flex items-center mb-4">
                  <FiInfo className="w-5 h-5 mr-2" />
                  <h2 className="text-lg font-medium">Who We Are</h2>
                </div>
                <WhoWeAreContent />
              </div>

              <div className="bg-black/20 border border-white/10 rounded-lg p-4">
                <div className="flex items-center mb-4">
                  <FiTarget className="w-5 h-5 mr-2" />
                  <h2 className="text-lg font-medium">Our Vision</h2>
                </div>
                <VisionContent />
              </div>

              <div className="bg-black/20 border border-white/10 rounded-lg p-4">
                <div className="flex items-center mb-4">
                  <FiStar className="w-5 h-5 mr-2" />
                  <h2 className="text-lg font-medium">Our Mission</h2>
                </div>
                <MissionContent />
              </div>

              <div className="bg-black/20 border border-white/10 rounded-lg p-4">
                <div className="flex items-center mb-4">
                  <FiUsers className="w-5 h-5 mr-2" />
                  <h2 className="text-lg font-medium">Success Stories</h2>
                </div>
                <SuccessStoriesContent />
              </div>
            </div>
          </div>

          {/* Desktop content */}
          <div className="flex-1 min-w-0 min-h-[500px] md:ml-56 hidden md:block">
            {activeTab === "whoweare" && <WhoWeAreContent />}
            {activeTab === "vision" && <VisionContent />}
            {activeTab === "mission" && <MissionContent />}
            {activeTab === "stories" && <SuccessStoriesContent />}
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="mt-12 relative z-10">
        <Footer />
      </div>
    </div>
  );
};

export default AboutUs;
